import { useState, useEffect } from "react";
import { getFirestore, collection, onSnapshot, deleteDoc, doc, setDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";

export const db = getFirestore();

export function useCollection(collectionName) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Wait for auth to be ready before listening
    const auth = getAuth();
    if (!auth.currentUser) {
      setItems([]);
      setLoading(false);
      return;
    }
    const ref = collection(db, collectionName);
    const unsub = onSnapshot(
      ref,
      (snap) => {
        setItems(snap.docs.map(d => ({ ...d.data(), _docId: d.id })));
        setLoading(false);
      },
      (error) => {
        console.warn(`Firestore ${collectionName}:`, error.message);
        setItems([]);
        setLoading(false);
      }
    );
    return unsub;
  }, [collectionName]);

  const add = async (item) => {
    await setDoc(doc(db, collectionName, String(item.id)), item);
  };

  const update = async (item) => {
    await setDoc(doc(db, collectionName, String(item.id)), item);
  };

  const remove = async (id) => {
    await deleteDoc(doc(db, collectionName, String(id)));
  };

  return [items, { add, update, remove, loading }];
}